class ContentBlockColumns extends HTMLElement {
  constructor() {
    super();
    this.initSlider();
  }

  initSlider() {
    new Swiper(".content-block-columns__slider", {
      slidesPerView: 1.2,
      spaceBetween: 4,
      loop: false,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        500: {
          slidesPerView: 1.2,
        },
        748: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
}

customElements.define("content-block-columns", ContentBlockColumns);
